import { makeStyles } from '@mui/styles';
import { subtitle1, body1 } from '../../../shared/theme/text.styles';

export const useAboutSectionStyles = makeStyles((theme) => ({
  aboutWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',

    [theme.breakpoints.down('lg')]: {
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center !important',
      textAlign: 'center',
    },
  },

  about: {
    width: '70%',
  },

  highlights: {
    display: 'flex',
    alignItems: 'flex-end',
    flexDirection: 'column',

    [theme.breakpoints.down('lg')]: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'center',
      columnGap: '20px',
      alignItems: 'center',
      marginTop: '50px',
      width: '90%',
    },
  },

  dHeading: {
    ...subtitle1,
    color: theme.palette.primary.main,
  },

  dSummary: {
    ...body1,
    width: '70%',
    marginTop: '20px !important',
    marginBottom: '20px !important',
    color: theme.palette.text.main,
    [theme.breakpoints.down('lg')]: {
      marginLeft: 'auto !important',
      marginRight: 'auto !important',
    },
  },
}));
